export const LogoMark = ({ size = 40, className = "" }) => (
  <img src="/assets/logo-apinity-mark.png" alt="APINITY" style={{ height: size, width: "auto" }} className={className} />
);

export const Logo = ({ size = 40, withWordmark = true, hideWordmarkOnMobile = false }) => (
  <div className="flex items-center gap-3" data-testid="app-logo">
    <LogoMark size={size} />
    {withWordmark && (
      <div className={`leading-none ${hideWordmarkOnMobile ? "hidden min-[480px]:block" : ""}`}>
        <span className="block font-serif text-2xl font-bold tracking-[0.14em] text-ink">APINITY</span>
        <span className="block font-cinzel text-[9px] tracking-[0.32em] text-terra">HAPPY AFFINITY</span>
      </div>
    )}
  </div>
);
